export function loadDirectTag(param) {
    let tag = document.getElementById(param.id + "script");
    const scriptEl = document.createRange().createContextualFragment(param.directTag);
    tag.parentNode.insertBefore(scriptEl, tag.nextSibling);
}